'use client';
import { Images } from '@/assets/imgs';
import { ObserverContainer } from '@/components/ObserverContainer';
import { splitLines } from '@/modules/utils/utils';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { motion, AnimatePresence } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { LinkButton } from '@/components/Buttons';

let timerId: any = null;

export const Slider = () => {
  const ref = useRef<HTMLHeadingElement>(null);

  const [active, setActive] = useState<number>(0);

  useEffect(() => {
    if (ref.current) {
      splitLines(ref.current);
    }
  }, []);

  useEffect(() => {
    timerId = setInterval(() => {
      if (active + 1 === data.length) setActive(0);
      else setActive(active + 1);
    }, 8000);

    return () => clearInterval(timerId);
  });
  const data = [
    {
      title: 'Arakine',
      description:
        "XBorg is a game-changer in the world of Web3 gaming. As an early investor, I've witnessed its revolutionary vision and teamwork in action, fostering interoperability and empowering players.",
    },
    {
      title: 'makeitr3al',
      description:
        'Having a Prometheus is like having a first-class ticket in the airport. You have plenty of privileges and everywhere you show up, the red carpet is getting rolled out for you.',
    },
    {
      title: 'Franck',
      description:
        'As a professional web3 researcher I have seen hundreds of projects, and XBorg easily stands at the top as an emerging project.',
    },
    {
      title: 'EzR3al',
      description:
        "The Prometheus collection isn't just art; it's a gateway to an extraordinary world of possibilities and benefits.",
    },
    {
      title: 'Nulien',
      description:
        'As a proud holder, I now enjoy unique opportunities and real governance power. A valuable NFT, an innovative concept, a strong team - XBorg has it all.',
    },
    {
      title: 'Arno',
      description:
        "I am so bullish on XBorg – having had the privilege to witness XBorg's journey from the very beginning, it's thrilling to see the swift and significant strides they're making in the gaming industry.",
    },
    {
      title: 'Ricky Bobby',
      description:
        'XBorg is an experienced team that puts the community first, ensures aligned interests, and looks to disrupt a massive emerging Esports 3.0 industry.',
    },
    {
      title: 'Mathieu',
      description:
        "It's by far the best combination for exploring the gaming world of tomorrow. By far the most useful NFT in my collection.",
    },
    {
      title: 'Kitty',
      description:
        "I firmly believe in the team's vision and I am delighted to continue to contribute to this adventure. If I had to do it all over again, I'd bet even more on the Prometheus and XBG!",
    },
  ];

  return (
    <div className="prometheus-slider">
      <div className="container">
        <div className="slider-main flex between">
          <ObserverContainer className="list flex column lexend-body-sl">
            {data.map((item, index) => (
              <Link
                href=""
                className={`slider-link flex ${
                  active === index ? 'active' : 'inactive'
                }`}
                key={index}
                onClick={(e) => {
                  e.preventDefault();
                  clearInterval(timerId);
                  setActive(index);

                  timerId = setInterval(() => {
                    if (active + 1 === data.length) setActive(0);
                    else setActive(active + 1);
                  }, 8000);
                }}
              >
                <div className="link-inner flex middle between w-full">
                  <span>{item.title}</span>
                  <svg
                    className="slider-link-arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </Link>
            ))}
          </ObserverContainer>

          <div className={clsx('right')}>
            {data.map((el, idx) => {
              return (
                <div
                  key={'slider-right-' + idx}
                  className={clsx('right-section', idx === active && 'active')}
                >
                  <div className="quote-box">
                    <Image
                      src={Images.prometheusNFT.quoteStart}
                      quality={100}
                      width={59}
                      height={64}
                      alt="quote"
                    />

                    <div className="quote-text">{el.description}</div>

                    <Image
                      className="quoteEnd"
                      src={Images.prometheusNFT.quoteEnd}
                      quality={100}
                      width={59}
                      height={64}
                      alt="quote"
                    />
                  </div>

                  <div className="list-index-wrapper">
                    <div className={clsx('line', idx === active && 'active')}>
                      <div className="red"></div>
                    </div>

                    <div className="flex middle list-index lexend-body-md">
                      <span className="current">0{active + 1}</span>
                      <div className="spacer" />
                      <span className="total">0{data.length}</span>

                      <div className="arrows">
                        <button
                          onClick={() => {
                            if (active === 0) return;
                            else setActive(+active - 1);
                          }}
                        >
                          <Image
                            className={clsx(
                              'invert',
                              active === 0 && 'disable',
                            )}
                            alt="arrow"
                            src={Images.infrastructure.arrowRight}
                            width={32}
                            height={32}
                          />
                        </button>{' '}
                        <button
                          onClick={() => {
                            if (active === data.length - 1) return;
                            else setActive(+active + 1);
                          }}
                        >
                          <Image
                            className={clsx(
                              active === data.length - 1 && 'disable',
                            )}
                            alt="arrow"
                            src={Images.infrastructure.arrowRight}
                            width={32}
                            height={32}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
